import { moduleFactory } from "@/factories/module";
import { _controlFlowLogicNotImplementedError } from "@/modules/control-flow/notImplemented";
import { sleep } from "@/modules/control-flow/sleep";
import { _assertUnreachableCase } from "@/modules/control-flow/unreachable";

export const controlFlowModule = moduleFactory.create({
  sleep: sleep,
  notImplementedError: _controlFlowLogicNotImplementedError,
  assertUnreachableCase: _assertUnreachableCase,
});
